import { topicsItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            话题广场
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            大家都在看的热门话题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            点击感兴趣的话题标签，发现更多精彩内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {topicsItems.map((topic, index) => (
            <a
              key={index}
              href="#index"
              className="group bg-background-50 rounded-xl p-4 md:p-5 text-center hover:bg-primary-50 transition-colors duration-200 cursor-pointer no-underline"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors duration-300 mb-3">
                <i className={`${topic.icon} text-xl`}></i>
              </div>
              <div className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                {topic.name}
              </div>
              <div className="text-xs text-foreground-500 mt-1">
                {topic.count} 篇内容
              </div>
            </a>
          ))}
        </div>

        <div className="mt-5 text-center">
          <span className="text-xs text-foreground-500">
            共 9 个活跃话题板块，持续更新中
          </span>
        </div>
      </div>
    </section>
  );
}